import request from '../request'

export default {
  getActuacionesIncendiosActivos: (data) => {
    return request.get(`actuaciones_medios_incendio_activos/${data.daysTimeBack}/${data.COD_CCAA}/${data.COD_PROV}`)
  }
}
